import React from "react";

type Props = {};

const InterestPaidPostConstructionHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <ul className="text-start text-greyDark leading-para">
        <li>
          The following is the criteria for claiming deduction under this section
          <ul>
            <li>
              If the property is constructed, then occupancy certificate should have been obtained
              for that property.
            </li>
            <li>
              If a ready to move in property has been purchased then the legal transfer of ownership
              of the property should be completed.
            </li>
          </ul>
        </li>
        <li>
          The maximum amount of deduction that one can claim under this section is Rs 2 lakhs.
        </li>
      </ul>
    </>
  );
};

export default InterestPaidPostConstructionHint;
